import { Scalars } from '../__generated__/pge-types';
import isPointInPolygon from 'point-in-polygon';

type Position = { lat: Scalars['Latitude']; lng: Scalars['Longitude'] };

// Copied over from OutageCenterMap so it can be reused in other places
// Have not updated the existing usages in the OutageCenterMap
export const PGE_SERVICE_BOUND_RESTRICTION = {
  north: 45.883, //45.883463369942405, -121.52473667082151
  east: -121.524,
  south: 44.756, //44.756834406783746, -124.52523870226115
  west: -124.525,
};
export const DEFAULT_MAP_CENTER = { lat: 45.5051, lng: -122.675 };

export const isLocationWithinPGEServiceBoundary = (
  location: Position,
): boolean => {
  //Taking approx polygon of the service location since the library doesn't support multipolygon.
  const ServiceBoundaryCoordinates_Approx: [number, number][] = [
    [-124.03071866967774, 44.60965800442504],
    [-121.32808195092774, 44.311690083215225],
    [-120.98750577905274, 45.68663693361016],
    [-123.88789640405274, 46.228897905112134],
    [-124.03071866967774, 44.60965800442504],
  ];

  const polygon = ServiceBoundaryCoordinates_Approx;
  const point: [number, number] = [location.lng, location.lat];

  return isPointInPolygon(point, polygon);
};

export const isValidCoordinate = (lat: number, lng: number) =>
  typeof lat === 'number' &&
  typeof lng === 'number' &&
  !isNaN(lat) &&
  !isNaN(lng) &&
  lat >= -90 &&
  lat <= 90 &&
  lng >= -180 &&
  lng <= 180;
